






























































































































































import { Component, Vue } from 'vue-property-decorator';
import StepSchedulePaymentDateWealthViewModel from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-wealth/step-schedule-payment-date-wealth-view-model';

@Component({ name: 'StepSchedulePaymentDateWealth' })
export default class StepSchedulePaymentDateWealth extends Vue {
  step_schedule_payment_date_model = Vue.observable(
    new StepSchedulePaymentDateWealthViewModel(this),
  );

  created() {
    this.step_schedule_payment_date_model.initialize();
  }
}
